import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import PopOver from '~/Common-Objects/UI/Popover/index'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import axios from '~/data/http/axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import AutomationFunctions from '../automation/addNew/automationFunctions'
import i18n from '~/i18n'

export default function SubscriberAutomations() {
    const { subscriberID } = useParams()
    const history = useHistory()
    const [automations, setAutomations] = useState(null)
    const [removing, setRemoving] = useState(null)

    const remove = (queueItem) => {
        setRemoving(queueItem)
    }

    const removeAutomation = async () => {
        await axios.delete(`/automation/${removing.AutomationId}/subscriber/${subscriberID}`)
        await getAutomations()
        setRemoving(null)
    }

    const getAutomations = async () => {
        const res = await axios.get(`/subscriber/${subscriberID}/automations`)
        setAutomations(res.data)
    }

    useEffect(() => {
        getAutomations()
    }, [subscriberID])

    const popoverStyle = { width: 500, borderRadius: 4 }
    if (removing) {
        popoverStyle.height = 185
        popoverStyle.display = 'flex'
        popoverStyle.justifyContent = 'center'
        popoverStyle.alignItems = 'center'
        popoverStyle.backgroundColor = 'grey'
    }

    const data = (automations || []).filter((a) => !!a.Automation)

    return (
        <Paper className='mar-t20 mar-b0'>
            <h4 className='mar-b20'>{i18n.t('subscribers:subscriber.automations.header')}</h4>
            {!automations && <LoadingIcons />}
            {!!automations && data.length === 0 && (
                <div>{i18n.t('subscribers:subscriber.automations.noAutomations')}</div>
            )}
            {!!automations && data.length > 0 && (
                <div>
                    {data.map((automation) => {
                        const step = automation.Automation
                            ? AutomationFunctions.getStepByGuid(automation.NextGuid, automation.Automation.steps)
                            : null
                        let classes = 'mar-r5 mar-b10 square-chip-large'
                        let tooltip = ''
                        if (automation.Finished) {
                            classes += ' square-chip-grey'
                        } else if (automation.Automation?.status === 'Paused') {
                            classes += ' square-chip-yellow'
                        } else if (!automation.Automation) {
                            classes += ' square-chip-red'
                        } else {
                            classes += ' square-chip-green'
                        }
                        return (
                            <PopOver
                                key={automation.id}
                                side='top'
                                avoidCollisions={true}
                                trigger={
                                    <SquareChip
                                        className={classes}
                                        tooltip={tooltip}
                                        for={automation.id}
                                        iconRight={<Icons icon='expand' />}
                                    >
                                        {automation.Automation?.name}
                                    </SquareChip>
                                }
                            >
                                <div style={popoverStyle}>
                                    {!!removing && (
                                        <div style={{}}>
                                            <div
                                                className='mar-b10'
                                                style={{ color: 'white', textAlign: 'center', fontSize: 18 }}
                                            >
                                                {i18n.t('subscribers:subscriber.automations.remove', {
                                                    name: removing.Automation.name
                                                })}
                                            </div>
                                            <div className='mar-b20' style={{ color: 'white', textAlign: 'center' }}>
                                                {i18n.t('subscribers:subscriber.automations.removeDetail')}
                                            </div>
                                            <div className='quickFlex' style={{ justifyContent: 'center' }}>
                                                <Button
                                                    className='button-sml mar-r10 button-red'
                                                    onClick={removeAutomation}
                                                >
                                                    {i18n.t('subscribers:subscriber.automations.delete')}
                                                </Button>
                                                <Button className='button-sml' onClick={() => setRemoving(null)}>
                                                    {i18n.t('subscribers:subscriber.automations.cancel')}
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                    {!removing && (
                                        <>
                                            {!automation.Automation && (
                                                <>
                                                    <div className='text-heavy text-lg mar-b10'>
                                                        {i18n.t('subscribers:subscriber.automations.deleted')}
                                                    </div>
                                                </>
                                            )}
                                            {!!automation.Automation && (
                                                <>
                                                    <div
                                                        className='quickFlex mar-b10'
                                                        style={{
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <div className='text-heavy text-md'>
                                                            {automation.Automation?.name}
                                                        </div>
                                                        <Button
                                                            className='button-sml button-primary'
                                                            onClick={() =>
                                                                history.push(
                                                                    '/cp/automation/addnew/' +
                                                                        automation.AutomationId +
                                                                        '?SubscriberId=' +
                                                                        subscriberID
                                                                )
                                                            }
                                                        >
                                                            {i18n.t('subscribers:subscriber.automations.view')}
                                                        </Button>
                                                    </div>
                                                    <hr className='mar-b10' />
                                                    <div className='mar-b10'>
                                                        <strong>
                                                            {i18n.t('subscribers:subscriber.automations.status')}:
                                                        </strong>{' '}
                                                        {automation.Automation.status}
                                                    </div>
                                                    <div className='mar-b10'>
                                                        <strong>
                                                            {i18n.t('subscribers:subscriber.automations.added')}:
                                                        </strong>{' '}
                                                        {DateTimeFunctions.formatDateTime(automation.createdAt)}
                                                    </div>
                                                    <div className='mar-b10'>
                                                        <strong>
                                                            {i18n.t('subscribers:subscriber.automations.lastAction')}:
                                                        </strong>{' '}
                                                        {DateTimeFunctions.formatDateTime(automation.updatedAt)}
                                                    </div>
                                                    <hr className='mar-b10' />
                                                    <div
                                                        className='quickFlex'
                                                        style={{ justifyContent: 'space-between', alignItem: 'center' }}
                                                    >
                                                        {!step && (
                                                            <div>
                                                                <strong>
                                                                    {i18n.t(
                                                                        'subscribers:subscriber.automations.stepNotFound'
                                                                    )}
                                                                </strong>
                                                            </div>
                                                        )}
                                                        {!!step && (
                                                            <div>
                                                                <strong>
                                                                    {i18n.t('subscribers:subscriber.automations.step')}:
                                                                </strong>{' '}
                                                                {AutomationFunctions.humanizeStep(step)}{' '}
                                                                {automation.Finished
                                                                    ? ''
                                                                    : '(' +
                                                                      DateTimeFunctions.formatDateTime(
                                                                          automation.ActionDate
                                                                      ) +
                                                                      ')'}
                                                            </div>
                                                        )}
                                                        {!!step && automation.Finished && (
                                                            <div>
                                                                <strong>
                                                                    {i18n.t(
                                                                        'subscribers:subscriber.automations.finished'
                                                                    )}
                                                                </strong>
                                                            </div>
                                                        )}
                                                        <Button
                                                            className='button-sml button-red'
                                                            onClick={() => remove(automation)}
                                                        >
                                                            {i18n.t('subscribers:subscriber.automations.removeButton')}
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </PopOver>
                        )
                    })}
                </div>
            )}
        </Paper>
    )
}
